import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getUserDetailRequest, getUserDetailRequestError, getUserDetailRequestSuccess } from "../../../slices/teams/members/GetUserDetailsSlice";
export const GetUserDetailApi = (id) => async (dispatch) => {
    try {
        dispatch(getUserDetailRequest());
        axiosInstance({
            method: "GET",
            url: `${endpoints.getUserDetail}/${id}`,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
              
                return dispatch(getUserDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUserDetailRequestError(_error));
            });
    } catch (error) { }
};
